import { Pipe, PipeTransform } from "@angular/core";
import { Decision, RequestType, RiskScore } from "../models/shared";

export type EnumType = RequestType | RiskScore | Decision;

@Pipe({
	name: "enum",
	standalone: true,
})
export class EnumPipe implements PipeTransform {
	transform(value: EnumType): string {
		switch (value) {
			case "BalanceInquiry":
				return "Balance Inquiry";
			case "NotEvaluated":
				return "Not Evaluated";
			default:
				return value;
		}
	}
}
